import type { ClinicalCase } from '@/types/clinicalCase';

/** Whether the case renders a line or a preparing state, which every viewer sees. */
export function hasClinicalCaseToShow(clinicalCase: ClinicalCase | undefined): boolean {
  if (clinicalCase?.status === 'written') {
    return clinicalCase.line.trim().length > 0;
  }

  return clinicalCase?.status === 'preparing';
}

const NBSP = '\u00A0';

const NON_BREAKING_HYPHEN = '\u2011';

/**
 * Display-only touch-ups so a measurement or marker never splits across lines: a number and its
 * unit, "HER2 3+", "Ki-67 70%", and the hyphen inside those markers. The stored line is never
 * changed and the screen reader label uses it as written.
 */
export function formatCaseLineForDisplay(line: string): string {
  return line
    .replace(/(\d) (cm|mm|mg|kg|Gy|mL|%)/g, `$1${NBSP}$2`)
    .replace(/\b(HER2|Ki-67|PD-L1|ER|PR) (\d)/g, `$1${NBSP}$2`)
    .replace(/Ki-67/g, `Ki${NON_BREAKING_HYPHEN}67`)
    .replace(/PD-L1/g, `PD${NON_BREAKING_HYPHEN}L1`);
}
